export enum SubscriptionState {
  /** No subscription has been created for this account. */
  None = 0,
  /** Subscription is active and in good standing. */
  Active = 1,
  /** A payment attempt failed; subscription is still accessible but needs attention. */
  PastDue = 2,
  /** Subscription was created but the first payment has not yet succeeded. */
  Incomplete = 3,
  /** Incomplete subscription expired without a successful payment. */
  IncompleteExpired = 4,
  /** Subscription has been fully canceled. */
  Canceled = 5,
  /** Subscription is in a free trial period. */
  Trialing = 6,
  /** Subscription is active but scheduled to cancel at the end of the current billing period. */
  PendingCancellation = 7,
}
